import React from 'react'
import MediaQuery from 'react-responsive'

import { AcornsIcon, Icon } from '@acorns/icons'
import { Footnote } from '@acorns/web-components'
import styled from 'styled-components'

import Container from 'components/Layout'
import Nav from 'components/Nav'
import themeValues, { style } from 'theme'

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 165px;
  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding: 35px 30px 0px;
    margin-top: 0px;
    position: absolute;
    top: 70px;
    left: 0px;
    width: 100vw;
    height: calc(100vh - 100px);
  }
`

const StyledFootnote = styled(Footnote)`
  font-style: italic;
  margin-top: 185px;
  margin-bottom: 0px;
  text-align: center;
  @media screen and (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    position: absolute;
    bottom: 0;
    margin-left: 30px;
    margin-right: 30px;
  }
`

const StyledSpinnerContainer = styled.div`
  position: absolute;
  top: 40%;
`

const CalculatingPortfolioSuccess = () => {
  return (
    <>
      <Nav hideProgressBar={true} title="Calculating Portfolio" />
      <MediaQuery maxWidth={themeValues.breakpoints.sm}>
        <Content>
          <StyledSpinnerContainer>
            <AcornsIcon icon={Icon.CheckmarkGreenNarrow} height={80} width={80} />
          </StyledSpinnerContainer>
          <StyledFootnote />
        </Content>
      </MediaQuery>
      <MediaQuery minWidth={themeValues.breakpoints.sm + 1}>
        <Container>
          <Content>
            <AcornsIcon icon={Icon.CheckmarkGreenNarrow} height={80} width={80} />
            <StyledFootnote />
          </Content>
        </Container>
      </MediaQuery>
    </>
  )
}

export { CalculatingPortfolioSuccess }
